<template>
  <div id="app" class="app" ref="app">
    <Header v-if="name != 'blank'"></Header>
    <router-view></router-view>
    <div class="flex1"></div>
    <Footer v-if="name != 'blank'"></Footer>

    
  </div>
</template>
<script>


import Header from "@/components/Header"
import { EventBus } from "./main"
export default {
  name: "App",
  components: {
    Header,
  },
  data() {
    return {
      resultMsg: '',
      name: '',
    }
  },
  watch: {
    $route(to, from, next) {
      var that = this
       that.$refs.app.scrollIntoView({ behavior: 'smooth' });

    }
  },
  mounted() {
    console.log('path===', this.$route.path)
   
   
  },
  methods: {
    
  }

}
</script>
<style lang="scss">
.footer_d {
	position: fixed;
	bottom: 0;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 12px 15px 24px;
	box-shadow: 0px -1px 16px 0px #00000014;
	z-index: 99999;

	.upload-btn {
		line-height: 44px;
		text-align: center;
		background-color: #007BC0;
		color: #fff;
		font-size: 16px;
	}
}
.btn_blue {
    margin: 0 23px;
    height: 46px;
    background: #007BC0;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-bottom: 15px;
   

}
.page_d{
  background: linear-gradient(180deg, #F2F8FF 0%, rgba(242, 248, 255, 0.2) 100%);

}
.el-loading-mask{
  background-color: transparent!important;
}
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
.hover2:hover {
  color: #C9E5F6;
}

.el-carousel__arrow {
  line-height: 36px;
}

.el-date-picker {
  width: auto !important;
}

.el-picker-panel__content {
  margin: 15px auto;
}

.user_no {
  margin-top: 26px;
  width: 170px;
}

.btn-next {}

.notify-btn-default {
  background-color: #D9D9D9 !important;
}

.result .layer {
  padding: 22px 38px 27px 38px;
}

.result .layer_li_title {
  font-weight: bold;
  color: #000;
  font-size: 16px;

}

.result .layer_hint {
  color: #000;
  margin-top: 26px;
  font-size: 12px;
}

.el-button--primary {
  background: #007BC0;
}

.el-message-box {
  position: fixed;
  width: 380px;
  left: calc(50% - 190px);
  top: 40vh !important;

}

.el-select__tags {
  justify-content: flex-end;
}

.notify-btn-primary {
  background-color: #007BC0 !important;
  border: 1px solid #007BC0 !important;
}

.picker_border {
  width: 13px;
  height: 1px;
  background-color: #D9D9D9;
  margin: 0 7px;

}

// @font-face {
//   font-family: 'MyCustomFont';
//   src: url('./static/font/BOSCHSANSCHS-REGULAR-V2.TTF') format('truetype');
//   font-weight: normal;
//   font-style: normal;
// }

body,
html,
* {
  font-family: 'MyCustomFont', system-ui, sans-serif !important;
  box-sizing: border-box;

}

/* 直接在组件内部覆盖Message的样式 */
.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 99px;
  height: 99px;
}
.hidden{
	display: none;
}
[class*=" el-icon-"],
[class^=el-icon-] {
  width: 92px !important;
}

// span.el-range-separator{
//   height: 100%;
//   line-height: 100%;
//   width: auto;
// }

[class*=" el-icon-"],
[class^=el-icon-] {
  width: 100%;
  height: 100%;
  line-height: inherit;
}

.el-upload--picture-card {
  line-height: 99px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  line-height: 100%;
  ;
  text-align: center;
}

.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: cover !important;
  display: block !important;
  width: 100%;
  height: 100%;
}

.custom-message {
  background-color: rgba(0, 0, 0, .6);
  color: #fff;

  [class*=" el-icon-"],
  [class^=el-icon-] {
    width: initial;
  }
}

.el-textarea.is-disabled .el-textarea__inner,
.el-textarea__inner {
  background: none !important;
  border: none !important;
  color: initial !important;
  text-align: right !important;

}

.el-date-picker__header {
  display: flex;
  align-items: center;
}

.el-date-picker__header--bordered {
  display: flex;
  align-items: center;

  .el-picker-panel__icon-btn {
    margin-top: 0;
  }
}

.el-message {
  min-width: 274px;
}

.el-message--info .el-message__content {
  color: #fff;
}

::-webkit-scrollbar {
  display: none;
  width: 0 !important;
}


.fixed_footer_H {
  height: 65px;
}

.fixed_footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  height: 84px;
  background: #fff;

  .PC_footer_btn {
    width: 345px;
    height: 44px;
    color: #fff;
    background: #007BC0;
    font-size: 16px;
  }
}

.app {
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  position: relative;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  /* border: 1px solid red; */

}

* {
  -webkit-overflow-scrolling: touch;
}

.input_R .el-input--suffix .el-input__inner {
  text-align: right !important;
}

.MyAccount .el-input,
.el-input--suffix .el-input__inner {
  text-align: left !important;
}

.pointer:hover {
  cursor: pointer !important;
}

.hoverColorpointer:hover {
  cursor: pointer !important;
  color: #025180 !important;
}

/* loading.component.css */
.btn_d {
  margin-top: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .btn_L {
    box-sizing: border-box;
    width: calc(50% - 7px);
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #007BC0;
    border: 1px solid #007BC0;
  }

  .btn_R {
    box-sizing: border-box;
    width: calc(50% - 7px);
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #007BC0;
    color: #fff;
  }
}

.red {
  font-weight: normal;
  color: #EB5336;
}

.form_d .el-input__prefix,
.form_d .el-input__suffix {
  height: initial;
  top: calc(50% - 15px);

}

.el-input__prefix {
  left: 12px;
}

.form_d .el-date-editor .el-input__prefix {
  top: calc(50% - 15px);

}

.form_d .seach_input {
  width: 99px;
  flex: initial !important;

  .el-input .el-select__caret {
    transform: initial;
    transition: initial;
    width: inherit;


  }

  .el-input__inner {
    color: transparent;
  }

  .el-input__suffix {
    margin-right: 10px;
    width: 74px;
    height: 28px;
    border-radius: 4px;
    background: #007BC0;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    top: calc(50% - 15px);
  }

  .el-icon-arrow-up:before {
    content: "Search";
    color: #fff;
  }

  .seach_input .form_d .el-select {
    display: flex;
    align-items: center;
  }

}

.loading-overlay {
  background: transparent;
  /* 去掉背景 */
}

.keep-all {
  word-break: break-word;
}

.el-input__icon {
  line-height: inherit !important;
  height: inherit !important;
}

.el-date-editor .el-range-separator {
  width: auto;
}

.el-range-editor.is-disabled input {
  background: none !important;
}

.none_hint {
  width: 100%;
  line-height: 50px;
  text-align: center;
}

.pagination_d {
  display: flex;
  justify-content: center;
  padding: 20px 0;

  .number,
  .btn-next,
  .btn-prev,
  .el-input__inner {
    border: 1px solid #007bc0 !important;
    border-color: #007bc0 !important;
    margin: 0 4px;
    border-radius: 0px;
    min-width: 40px !important;
    height: 40px !important;
    text-align: center !important;
    line-height: 40px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
    color: #007bc0;
    font-weight: normal;

  }

  .el-input__inner:focus {
    border-color: #007bc0 !important;
    border: 1px solid #007bc0 !important;
  }


  .el-pager li.active {
    background: #007bc0;
    color: #fff;
  }

}
.el-switch__label.is-active{
  color: #007bc0;
}
.el-input,
.el-input--suffix .el-input__inner,
.input .el-input--suffix .el-input__inner {
  text-align: right;
}

.image-uploader {
  display: flex;
}
.el-upload-list{
  display: flex;
}
.upload-item-btn{
  width: 100%;
 flex-wrap: wrap;

}

.el-icon-loading {
  color: #005432 !important;
}

input:disabled {
  // background: none;
}

.ellipsis1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ellipsis3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.flex1 {
  flex: 1;
}

.relative {
  position: relative;
}

img {
  width: 100%;
  height: auto;
}

.logo .icon-logo {
  width: 186px;
  height: 41px;
}

.ydShow_padding0 {
  padding: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.form_appName {
  flex: 1;
}

.input {
  height: 100%;
  flex: 1;
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0;
  border: none !important;
}

.input_L {
  white-space: nowrap;

}


@media (max-width: 1200px) and (min-width: 500px) {
  .container {
    max-width: 700px;
  }
}

@media (max-width: 1200px) and (min-width: 300px) {
  .input {
    height: 100%;
    // border: 1px solid red !important;
  }

  .input_d .input_R {
    max-width: 203px;
  }

  .OTP {
    max-width: 200px !important;
    // border: 1px solid blueviolet!important;
  }




  .form_appName {
    width: 200px;
    margin-right: 0;
    flex: initial;
  }

  .ydShow {
    display: block !important;
  }

  .pcShow {
    display: none !important;
  }

  .fixed_footer_H {
    height: 85px;
  }

  .fixed_footer {
    bottom: 73px;
  }

  .logo .icon-logo {
    width: 118px;
    height: 26px;
  }

}

@media (min-width: 1200px) {
  .pcShow {
    display: block !important;
  }

  .layer {
    max-height: 60vh;
    overflow-y: scroll;
  }

  .ydShow {
    display: none !important;
  }
}

#first {
  width: 100px;
  height: 100px;
  background-color: #fff;
  font-size: 12px;
}

.el-loading-spinner .el-loading-text {
  color: #007BC0 !important;
}

.el-loading-spinner i {
  color: #007BC0 !important;
  stroke-width: 3.5 !important;
}

.pc_banner_title {
  margin-top: 42px;
  font-size: 28px;
  color: #000000;
  margin-bottom: 35px;
  font-weight: bold;
}

.ph_banner_title {
  margin-top: 16px;
  font-size: 18px;
  color: #000000;
  margin-bottom: 17px;
  font-weight: bold;
}

.border_bottom {
  border-bottom: 1px solid #D9D9D9;
 
}
</style>